export const PI_DATA_REQUEST = 'PI_DATA_REQUEST';
export const PI_DATA_SUCCESS = 'PI_DATA_SUCCESS';
export const PI_DATA_FAIL = 'PI_DATA_FAIL';
